const authorVars = 'author { id handle avatar name }'

const postBaseValues = `
  id
  ident
  ${authorVars}
  title
  summary
  visible
  votes
  locked
  insertedAt
  updatedAt
`

export const postListVars = `
  ${postBaseValues}
  bodytrunc
`

export const postLoadVars = `
  ${postBaseValues}
  body
`

export const replyVars = `
  id
  ${authorVars}
  votes
  parentId
  body
  summary
  visible
  locked
  insertedAt
  updatedAt
`
